module.exports = __webpack_public_path__ + "img/stage.c0a7b408.svg";